<template>
  <div class="pm-dialog-flag">

    <div class="flex justify-center flag-input-area" >
      <vs-input
        class="flag-input"
        :class="[ 
          ( flagValue ? 'input-any' : 'input-null' ),
        ]"
        label=""
        v-model="flagValue"
        v-validate="'required'"
        name="flagValue"
        data-vv-as="flagValue"
      />
    </div>

    <div class="flex justify-center">
      <div class="vs-row flex justify-start flag-list-width">
        <div class="vs-col candidate-list" v-for="(master,index) in masterList" :key="index" @mousedown="onKeyDown(master.value)">
          <vs-chip class="pm-input-key flag-item" color="#828282"
            onMouseOut="this.style.background='#828282'" 
            onMouseOver="this.style.background='#346c88'"
          >
            {{ master.value }}
          </vs-chip>
        </div>
      </div>
    </div>

    <div class="flex justify-center">
      <div class="flex justify-end flag-list-width">
        <vs-button 
          class="clear-button"
          color="#828282"
          onMouseOut="this.style.background='#828282'" 
          onMouseOver="this.style.background='#346c88'"
          @mousedown="onClear"
        >クリア</vs-button>
      </div>
    </div>
    <div class="flex justify-center">
      <vs-button 
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
      >
        保存
      </vs-button>
      <vs-button
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("portMasterDestinationWork");

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
  },
  data() {
    return {
      flagValue: "",
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    masterList() {
      return this.masterMap['flag'];
    },
    enableSave() {
      return true; // this.flagValue
    },
  },
  methods: {
    initData() {
      this.flagValue = this.valueMap ? this.valueMap.value : "";
    },
    onKeyDown(key){
      this.flagValue = this.flagValue ? (this.flagValue + key) : key;
    },
    onClear() {
      this.flagValue = "";
    },
    onSubmit(isUpdateTimeStamp) {
      let mode = []
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey] = this.flagValue ? this.flagValue : null;
      this.$emit('updateValue',this.taskId, updateKeyValueMap, mode);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-flag {
  .flag-input {
    width: 9rem;
    input {
      width: 100%;
      border-radius: 2%;
      font-weight: bold;
      font-size: 150% !important;
    }
  }
  .outer-area {
    padding: 1rem;
  }
  .candidate-list {
    margin:0.2rem;
    padding: 0rem;
    .con-vs-chip {
      border-radius:6px;
      height:3rem;
      font-size: 120%;
      min-width: 3rem;
    }
  }
  .clear-button {
    height: 2.8rem;
    margin: 0.5rem 0.5rem 1rem 0;
  }
  .flag-list-width {
    width: 84%;
  }
  .flag-input-area {
    margin-bottom: 1rem;
  }
  .flag-item {
    border-radius: 5px;
    font-size: 120%;
    min-width: 2rem;
  }
  .vs-input--input {
    height: 3rem;
    text-align: center;
    background-color: $pm-white;
  }
  .input-any {
    .vs-input--input {
      background-color: $pm-white;
      border: 2px solid $pm-blue !important;
    }
  }
  .input-null {
    .vs-input--input {
      background-color: $pm-light-gray;
    }
  }
  .save-button {
    margin: 0 1rem;
    width: 30%
  }

}
</style>

